<div class="game-rules__container--title">
    <p>{{'SETTINGS.GAME_RULES' | translate}}</p>
</div>
<div class="game-rules__container--content" [innerHTML]="rules | sanitize"></div>